import { ResolveFn } from '@angular/router';
import { TabSdk } from '@techextensor/tab-sdk';

/**
 * Pre-flights the SignalR hub connection before an authenticated route renders.
 *
 * Notifications are NOT connected here — they're a header-chrome feature with
 * no per-component join requirement, so they connect lazily inside HeaderComponent.
 *
 * SignalR stays here because tab-grid (and any future component using
 * `signalR.register`) has a join-before-connect race that's only safely closed
 * by waiting for the hub to be CONNECTED before the screen mounts.
 */
export const signalRResolver: ResolveFn<boolean> = async () => {
  await TabSdk.signalR.connect();
  return true;
};
